/* 전 페이지 공통 */

function watchStickyHeader() {
  const header = document.querySelector('.shopify-section--header');
  if (!header) return;

  let start = 0;
  let ticking = false;

  function measure() {
    header.classList.remove('is-stuck');
    start = header.getBoundingClientRect().top + window.scrollY;
    paint();
  }

  function paint() {
    header.classList.toggle('is-stuck', window.scrollY > start);
  }

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      paint();
    });
  }, { passive: true });

  window.addEventListener('resize', measure);
  measure();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', watchStickyHeader);
} else {
  watchStickyHeader();
}

function initShippingBar(bar) {
  const fill = bar.querySelector('[data-shipping-fill]');
  if (!fill) return;

  function paint() {
    const threshold = parseFloat(bar.getAttribute('threshold')) || 0;
    const total = parseFloat(bar.getAttribute('total-price')) || 0;
    const passed = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 0;

    fill.style.width = passed + '%';
  }

  new MutationObserver(paint).observe(bar, {
    attributes: true,
    attributeFilter: ['total-price', 'threshold'],
  });

  paint();
}

function initCart(scope) {
  (scope || document).querySelectorAll('free-shipping-bar').forEach(initShippingBar);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initCart());
} else {
  initCart();
}

document.addEventListener('shopify:section:load', (event) => initCart(event.target));

/* 캐러셀 진행바 — 상세 추천 · 장바구니 추천 공용 */
function initCarouselProgress(root) {
  if (root.dataset.progressReady === 'true') return;

  const carousel = document.getElementById(root.dataset.carouselProgress);
  const bar = root.querySelector('.pdp-carousel-progress__bar');

  if (!carousel || !bar) return;

  root.dataset.progressReady = 'true';

  let travel = 0;    // 막대가 움직일 수 있는 거리(px)
  let maxScroll = 0; // 트랙이 스크롤될 수 있는 거리(px)
  let ticking = false;

  function measure() {
    const visible = carousel.clientWidth;
    const total = carousel.scrollWidth;

    if (total <= visible + 1) {
      root.classList.remove('is-visible');
      travel = 0;
      maxScroll = 0;
      return;
    }

    root.classList.add('is-visible');
    maxScroll = total - visible;

    const lane = root.clientWidth;
    const width = lane * (visible / total);

    bar.style.width = width + 'px';
    travel = lane - width;
    paint();
  }

  /* 스크롤 중에는 transform 만 바꾼다 */
  function paint() {
    if (maxScroll <= 0) return;

    const passed = Math.min(1, Math.max(0, carousel.scrollLeft / maxScroll));
    bar.style.transform = 'translateX(' + passed * travel + 'px)';
  }

  carousel.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      paint();
    });
  }, { passive: true });

  new ResizeObserver(measure).observe(carousel);
  measure();
}

function initCarouselProgressAll(scope) {
  (scope || document).querySelectorAll('[data-carousel-progress]').forEach(initCarouselProgress);

  (scope || document).querySelectorAll('product-recommendations').forEach((element) => {
    if (element.dataset.progressWatched === 'true') return;
    element.dataset.progressWatched = 'true';

    new MutationObserver(() => initCarouselProgressAll(element)).observe(element, { childList: true });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initCarouselProgressAll());
} else {
  initCarouselProgressAll();
}

document.addEventListener('shopify:section:load', (event) => initCarouselProgressAll(event.target));

/* 마우스로 끌어서 가로 스크롤 — 스냅 없이 손끝을 따라간다 */
function initDragScroll(track) {
  if (track.dataset.dragReady === 'true') return;
  track.dataset.dragReady = 'true';

  let holding = false;
  let moved = false;
  let startX = 0;
  let startLeft = 0;

  track.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse') return;

    holding = true;
    moved = false;
    startX = event.clientX;
    startLeft = track.scrollLeft;
  });

  track.addEventListener('pointermove', (event) => {
    if (!holding) return;

    const dx = event.clientX - startX;

    /* 손떨림은 클릭으로 둔다 */
    if (!moved && Math.abs(dx) < 4) return;

    if (!moved) {
      moved = true;
      track.classList.add('is-dragging');
      track.setPointerCapture(event.pointerId);
    }

    track.scrollLeft = startLeft - dx;
    event.preventDefault();
  });

  const release = () => {
    holding = false;
    track.classList.remove('is-dragging');
  };

  track.addEventListener('pointerup', release);
  track.addEventListener('pointercancel', release);

  /* 끌고 나서 손을 떼면 링크가 열리지 않게 */
  track.addEventListener('click', (event) => {
    if (!moved) return;
    event.preventDefault();
    event.stopPropagation();
  }, true);

  track.addEventListener('dragstart', (event) => event.preventDefault());
}

document.querySelectorAll('[data-drag-scroll]').forEach(initDragScroll);

/* 로그인 뒤 원래 페이지로 — 쇼피파이가 return_to 를 무시하고 고객 허브로 보낸다.
   인증이 다른 출처를 거쳐 돌아오므로 sessionStorage 는 날아갈 수 있다 */
const RETURN_KEY = 'fs:return-to';
const RETURN_TTL = 10 * 60 * 1000;

function rememberReturn(path) {
  try {
    localStorage.setItem(RETURN_KEY, JSON.stringify({ path, at: Date.now() }));
  } catch (error) {
    /* 저장이 막히면 그냥 넘어간다 */
  }
}

function takeReturn() {
  let raw = null;

  try {
    raw = localStorage.getItem(RETURN_KEY);
    localStorage.removeItem(RETURN_KEY);
  } catch (error) {
    return null;
  }

  if (!raw) return null;

  try {
    const saved = JSON.parse(raw);
    if (!saved.path) return null;

    /* 오래된 값으로 엉뚱한 데서 튕기지 않도록 */
    if (Date.now() - saved.at > RETURN_TTL) return null;

    return saved.path;
  } catch (error) {
    return null;
  }
}

/* 로그인 링크를 바꿔치기하는 앱이 있다.
   전파를 막아도 놓치지 않도록 캡처 단계에서, 클릭보다 앞선 pointerdown 도 함께 듣는다 */
function catchReturnClick(event) {
  const holder = event.target.closest('[data-return-here]');
  if (!holder) return;

  rememberReturn(holder.dataset.returnHere || location.pathname);
}

document.addEventListener('pointerdown', catchReturnClick, true);
document.addEventListener('click', catchReturnClick, true);

/* 고객 허브에 도착했거나 로그인 직후 돌아온 순간 */
const landedFromLogin =
  location.pathname.includes('/a/customerhub') || location.search.includes('shop_sign_in=true');

if (landedFromLogin) {
  const target = takeReturn();
  if (target) location.replace(target);
}

/* 확인 창 — 테마의 x-modal 을 그대로 쓴다. 어디서든 부를 수 있다 */
window.fsConfirm = function (options) {
  const dialog = document.querySelector('[data-confirm-dialog]');
  if (!dialog) return Promise.resolve(window.confirm(options.message));

  const title = dialog.querySelector('[data-confirm-title]');
  const message = dialog.querySelector('[data-confirm-message]');
  const ok = dialog.querySelector('[data-confirm-ok]');
  const cancel = dialog.querySelector('[data-confirm-cancel]');

  title.textContent = options.title || '';
  title.hidden = !options.title;
  /* 모바일에서 줄바꿈을 따로 두고 싶으면 mobileMessage */
  const mobile = window.matchMedia('(max-width: 999px)').matches;
  message.textContent = (mobile && options.mobileMessage) || options.message || '';
  ok.textContent = options.confirm || 'Remove';
  cancel.textContent = options.cancel || 'Cancel';

  /* 창 하나만 따로 꾸밀 때 — 다음에 부를 때는 다시 빠진다 */
  dialog.classList.toggle('confirm-dialog--wide', Boolean(options.wide));

  return new Promise((resolve) => {
    let settled = false;

    const finish = (answer) => {
      if (settled) return;
      settled = true;

      ok.removeEventListener('click', onOk);
      cancel.removeEventListener('click', onCancel);
      dialog.removeEventListener('dialog:after-hide', onHide);

      resolve(answer);
    };

    /* 닫히는 애니메이션이 끝난 뒤 값을 넘긴다.
       cancelValue 를 주면 취소 버튼이 닫기(X·바깥 클릭)와 다른 값을 낸다 */
    const onOk = () => { dialog.hide(); finish(true); };
    const onCancel = () => {
      dialog.hide();
      if (options.cancelValue !== undefined) finish(options.cancelValue);
    };
    const onHide = () => finish(false);

    ok.addEventListener('click', onOk);
    cancel.addEventListener('click', onCancel);
    dialog.addEventListener('dialog:after-hide', onHide);

    dialog.show();
  });
};

/* 세트 삭제 — 구성품이 여러 줄로 담기므로 같은 묶음을 한 번에 뺀다 */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-bundle-remove]');
  if (!button) return;

  event.preventDefault();

  const group = button.dataset.bundleRemove;
  if (!group || button.dataset.busy === 'true') return;

  const confirmed = await window.fsConfirm({
    title: button.dataset.bundleTitle || '',
    message:
      'This item is part of a bundle. Removing it will remove every item in that bundle from your cart.',
    confirm: 'Remove bundle',
    cancel: 'Keep it',
  });

  if (!confirmed) return;

  button.dataset.busy = 'true';

  try {
    const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    const updates = {};

    cart.items.forEach((item) => {
      /* 묶음 값은 두 곳에 있다. 고객에게 보이는 Part of, 그리고 앱 내부의 _bundle.
         할인이 없는 번들은 _bundle 만 붙으므로 그것도 함께 본다 */
      const carries = Object.entries(item.properties || {}).some(([key, value]) => {
        if (typeof value !== 'string') return false;
        if (key === '_bundle') return value === group;

        return key.charAt(0) !== '_' && value.includes(group);
      });

      if (carries) updates[item.key] = 0;
    });

    if (!Object.keys(updates).length) return;

    await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });

    window.location.reload();
  } catch (error) {
    button.dataset.busy = 'false';
  }
});

/* 회원 증정 안내 — 비로그인 고객이 담기 전에 로그인을 권한다.
   상품 폼에는 buy-buttons.liquid 가 제품 ID 와 로그인 상태를 남기고,
   어느 제품에 어떤 문구를 띄울지는 회원 증정 팝업 섹션(member-gift-popup)의 JSON 에서 찾는다.
   테마 product-form 보다 먼저 받도록 문서 캡처 단계에서 듣는다 */
let memberGiftPopups;

function findMemberGiftPopup(productId) {
  if (!memberGiftPopups) {
    const source = document.querySelector('[data-member-gift-config]');

    try {
      memberGiftPopups = source ? JSON.parse(source.textContent).filter(Boolean) : [];
    } catch (error) {
      memberGiftPopups = [];
    }
  }

  /* 같은 제품이 여러 블록에 있으면 위쪽 블록 */
  return memberGiftPopups.find((popup) => popup.products.includes(Number(productId)));
}

/* 테마 편집에서 섹션을 고치면 다시 읽는다 */
document.addEventListener('shopify:section:load', () => {
  memberGiftPopups = undefined;
});

async function waitForCartGrowth(before, timeout = 10000, stopped = () => false, need = 1) {
  const until = Date.now() + timeout;

  while (Date.now() < until) {
    await new Promise((resolve) => setTimeout(resolve, 400));
    if (stopped()) return false;

    try {
      const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      if (cart.item_count - before >= need) return true;
    } catch (error) {
      /* 한 번 못 읽어도 다시 본다 */
    }
  }

  return false;
}

/* 담기는 테마에 맡기고, 장바구니가 늘어난 것을 보고 끝났다고 본다.
   번들 앱이 담기 요청을 가로채며 테마의 완료 신호를 끊는 일이 있어 신호를 기다리지 않는다 */
async function submitAndWait(gate, form, submitter, size) {
  let before = 0;

  try {
    before = (await (await fetch(`${Shopify.routes.root}cart.js`)).json()).item_count;
  } catch (error) {
    /* 못 읽으면 0 에서 센다 */
  }

  /* 담기 실패를 두 가지로 가린다.
     - 테마가 담았다면 품절 시 cart:error 를 낸다
     - 번들 앱(Amplify)이 가로채 담으면 cart:error 가 나가지 않고, 품절 옵션만 빼고
       나머지를 담기도 한다. 그래서 세트 하나만큼(섹션의 세트 구성 수량 × 수량) 늘어야 성공 */
  let failed = false;
  const onError = () => { failed = true; };
  form.addEventListener('cart:error', onError);

  const quantity = Number(new FormData(form).get('quantity')) || 1;

  gate.dataset.giftGatePassed = 'true';
  form.requestSubmit(submitter && submitter.form === form ? submitter : undefined);

  const added = await waitForCartGrowth(before, 10000, () => failed, size * quantity);
  gate.dataset.giftGatePassed = 'false';
  form.removeEventListener('cart:error', onError);

  return added && !failed;
}

/* 담기면 테마가 카트 드로워를 연다. 창을 먼저 띄우면 드로워가 열리며 초점을
   가져가 창이 닫힌다. 드로워가 다 열린 뒤에 띄운다 */
async function waitForDrawerOpen(timeout = 1500) {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  if (drawer.hasAttribute('open')) {
    /* 이미 열리는 중 — 여는 동작이 끝날 만큼만 */
    await new Promise((resolve) => setTimeout(resolve, 400));
    return;
  }

  await new Promise((resolve) => {
    const timer = setTimeout(resolve, timeout);

    drawer.addEventListener(
      'dialog:after-show',
      () => {
        clearTimeout(timer);
        resolve();
      },
      { once: true },
    );
  });
}

document.addEventListener(
  'submit',
  async (event) => {
    const gate = event.target.closest('[data-member-gift-gate]');
    if (!gate || gate.dataset.giftGatePassed === 'true') return;

    /* 섹션에 등록되지 않은 제품은 테마가 그대로 담는다 */
    const popup = findMemberGiftPopup(gate.dataset.memberGiftProduct);
    if (!popup) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const form = event.target;
    const submitter = event.submitter;
    const size = Number(popup.size) || 1;

    /* 회원 — 무조건 담고, 담긴 뒤에 증정품 받는 곳을 알린다.
       More Shopping·닫기는 그대로 머문다 (드로워는 테마가 연다) */
    if (gate.dataset.memberGiftGate === 'member') {
      if (!(await submitAndWait(gate, form, submitter, size))) return;

      await waitForDrawerOpen();

      const next = await window.fsConfirm({
        ...popup.member,
        cancelValue: 'buy',
        wide: true,
      });

      if (next === 'buy') location.href = `${Shopify.routes.root}checkout`;
      return;
    }

    const choice = await window.fsConfirm({
      ...popup.guest,
      cancelValue: 'buy',
      wide: true,
    });

    /* 로그인 — 담지 않고 보낸다. 돌아오면 로그인 상태라 창 없이 담긴다.
       숨겨둔 로그인 링크를 누르면 다른 로그인 링크와 같은 길로 간다 */
    if (choice === true) {
      const login = gate.querySelector('[data-member-gift-login]');

      if (login) {
        login.click();
      } else {
        rememberReturn(location.pathname);
        location.href = `${Shopify.routes.root}account/login`;
      }

      return;
    }

    if (choice !== 'buy') return;

    if (await submitAndWait(gate, form, submitter, size)) location.href = `${Shopify.routes.root}checkout`;
  },
  true,
);

/* FAQ 그룹 탭 — 선택한 그룹만 남긴다 */
function initFaqTabs() {
  document.querySelectorAll('[data-faq-tabs]').forEach((bar) => {
    if (bar.dataset.ready === 'true') return;
    bar.dataset.ready = 'true';

    const root = bar.closest('.faq');
    if (!root) return;

    const tabs = bar.querySelectorAll('[data-faq-tab]');
    const groups = root.querySelectorAll('[data-faq-group]');

    const activate = (tab) => {
      if (!tab) return;

      tabs.forEach((item) => item.classList.toggle('is-active', item === tab));

      groups.forEach((group) => {
        group.classList.toggle('is-active', group.dataset.faqGroup === tab.dataset.faqTab);
      });
    };

    bar.addEventListener('click', (event) => {
      activate(event.target.closest('[data-faq-tab]'));
    });

    /* 주소 끝에 # 를 붙여 특정 탭을 연 채로 들어올 수 있다.
       예) /pages/faq#cat-shipping */
    const fromHash = () => {
      const id = decodeURIComponent(window.location.hash.slice(1));
      if (!id) return;

      activate(bar.querySelector(`[data-faq-tab="${CSS.escape(id)}"]`));
    };

    fromHash();
    window.addEventListener('hashchange', fromHash);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFaqTabs);
} else {
  initFaqTabs();
}

/* 테마 편집에서 블록을 다시 그릴 때 */
document.addEventListener('shopify:section:load', initFaqTabs);

/* 맨 위로 — 조금 내려가면 나타난다 */
function initFloatTop() {
  const button = document.querySelector('[data-float-top]');
  if (!button) return;

  /* display 는 전이가 안 먹는다. 몸통 클래스로 바꿔 흐리게 나타나게 한다.
     Stamped 리워드 버튼도 같은 클래스에 묶여 함께 뜨고 함께 사라진다 */
  button.hidden = false;

  let waiting = false;

  const paint = () => {
    document.body.classList.toggle('has-scrolled', window.scrollY > 400);
  };

  button.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  window.addEventListener('scroll', () => {
    if (waiting) return;
    waiting = true;

    requestAnimationFrame(() => {
      waiting = false;
      paint();
    });
  }, { passive: true });

  paint();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFloatTop);
} else {
  initFloatTop();
}

/* 공지 바 지키기 — 번들 앱(Amplify)이 상세페이지에서 상품 가격처럼 보이는 글자를 찾아
   할인가로 바꾸는데, 공지 바의 "$99+" 가 6세트 가격($99.10)과 맞아 함께 바뀐다.
   앱 쪽에 가격 위치를 정하는 설정이 없어, 앱이 끼워 넣으면 원래 문구로 되돌린다 */
function guardAnnouncements() {
  const items = document.querySelectorAll('[data-announcement-html]');
  if (!items.length) return;

  /* 앱이 계속 다시 쓰더라도 서로 끝없이 주고받지 않도록 */
  let restores = 0;

  const restore = (item) => {
    if (restores >= 20) return;
    if (!item.querySelector('[class*="picky"]')) return;

    restores += 1;
    item.innerHTML = item.dataset.announcementHtml;
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      /* 글자만 바뀐 경우 target 이 텍스트 노드다 */
      const node = mutation.target.nodeType === Node.TEXT_NODE ? mutation.target.parentElement : mutation.target;
      const item = node && node.closest('[data-announcement-html]');
      if (item) restore(item);
    });
  });

  items.forEach((item) => {
    restore(item);
    observer.observe(item, { childList: true, subtree: true, characterData: true });
  });
}

guardAnnouncements();
